<div id="print-section">
<div class="header">
    <img src="https://konyaolgunlasma.com/assets/images/olgunlasmalogo.png" alt="Logo" class="logo">
</div>

<table>
<tr>
  <td colspan="3">ÜRÜN BİLGİ FORMU</td>
</tr>
<tr>
  <td>Kategori Adı</td>
  <td>Giyim</td>
  <td rowspan="7">
    <div class="container">
      <img src="https://konyaolgunlasma.com/sistem/uploads/images/7ddb45a06f54c5675cfb3743bd29f81f.png" alt="Resim 1">
      <img src="https://konyaolgunlasma.com/sistem/uploads/images/7ddb45a06f54c5675cfb3743bd29f81f.png" alt="Resim 2">
  </div>
  </td>
</tr>
<tr>
  <td>Ürün Kodu</td>
  <td>G-1</td>
</tr>
<tr>
  <td>Ürün Adı</td>
  <td>Yeşil Türbe Elbisesi</td>
</tr>
<tr>
  <td>Koleksiyon Adı</td>
  <td>Mevlana ve Selçuklu Eserleri Koleksiyonu</td>
</tr>
<tr>
  <td>Malzeme Bilgisi</td>
  <td>Yeşil İpek Şantuk, Mavi Şifon, Mavi Saten Çarpana Dokuma, Metal Aksesuar</td>
</tr>
<tr>
  <td>Teknik Özellikler</td>
  <td>Ürün, elbise, kemer ve pelerin olmak üzere 3 parçadan oluşmaktadır.</td>
</tr>
<tr>
  <td>Ürün Hikâyesi</td>
  <td>Türkiye’nin en çok ziyaret edilen müzelerinden Mevlana Müzesi’nin Kubbei Hadra’sı, bilinen adıyla Yeşil Kubbesinden esinlenerek tasarlanmış koleksiyon kıyafeti olarak üretilmiştir.</td>
</tr>
</table>
<div class="footer">
<p>Konya Olgunlaşma Enstitüsü</p>
</div>
</div>

<button printSectionId="print-section" ngxPrint  #printButton></button>